/**
 * When Buddy is back, in the words the composer, the meter and the limit notice share (R43): „o 14:20"
 * later today, „w czwartek o 09:00" on another day; `null` when the server named no time.
 */

import type { TFunction } from 'i18next';

import { resetMoment } from '~/entities/ai-conversation';
import { dateTimeFormat } from '~/shared/lib/intlCache';

export function resetWords(t: TFunction, resetsAt: string | null, now: Date, locale: string): string | null {
  if (resetsAt === null) return null;
  const moment = resetMoment(resetsAt, now);
  const time = dateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(moment.at);
  return moment.today
    ? t('web:aiPlan.reset.today', { time })
    : t('web:aiPlan.reset.onDay', { day: t(`web:aiPlan.reset.weekday.${String(moment.isoWeekday)}`), time });
}
